var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function FoodIcon() {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "13", height: "12", viewBox: "0 0 13 12", fill: "none" }, { children: _jsx("path", { d: "M1.91667 12L0.983337 11.0667L7.81667 4.23333C7.61667 3.76667 7.58889 3.23889 7.73334 2.65C7.87778 2.06111 8.19445 1.53333 8.68334 1.06667C9.27223 0.477778 9.92778 0.133333 10.65 0.0333333C11.3722 -0.0666667 11.9611 0.111111 12.4167 0.566667C12.8722 1.02222 13.05 1.61111 12.95 2.33333C12.85 3.05556 12.5056 3.71111 11.9167 4.3C11.45 4.78889 10.9222 5.10556 10.3333 5.25C9.74445 5.39444 9.21667 5.36667 8.75 5.16667L7.91667 6L12.9833 11.0667L12.05 12L6.98334 6.96667L1.91667 12ZM3.88334 6.3L1.88334 4.3C1.28334 3.7 0.983337 2.98333 0.983337 2.15C0.983337 1.31667 1.28334 0.6 1.88334 0L6.01667 4.16667L3.88334 6.3Z", fill: "#2B3737" }) })));
}
